import { GetItemsRequest, GetItemsResponse } from '../../types';
import { MicroserviceRequest } from '../../../../utils/request/microservice.request';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';
import { CompanyFilterDashboardDataProvider } from './CompanyFilterDashboardDataProvider';
import { AvailableCompaniesSource } from '../../../../../../../libs/shared/dtos/types/dashboards/src/lib/shared-dtos-dashboards-gz-console';

export class CompanyFilterDashboardAsmDataProvider extends CompanyFilterDashboardDataProvider {
  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await MicroserviceRequest.makeRequest<GetCompaniesRequest, GetCompaniesResponse>(
        'ProtectedEntities',
        'getCompaniesWithCount',
        {
          limit: request.limit,
          params: {
            includeOnlyWithCompaniesAccess: true,
            includeOwnCompanyWithAnyNetworkAccess: true,
            source: AvailableCompaniesSource.FROM_ASM,
          },
        }
      );

      return {
        items: response.targets.map(({ companyId, companyName }) => ({
          value: companyId,
          label: companyName,
        })),
        totalItemsCount: response.totalCount,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await MicroserviceRequest.makeRequest<GetCompaniesRequest, GetCompaniesResponse>(
        'ProtectedEntities',
        'getCompaniesWithCount',
        {
          page: request.page,
          limit: request.limit,
          companyName: request.searchValue,
          params: {
            includeOnlyWithCompaniesAccess: true,
            includeOwnCompanyWithAnyNetworkAccess: true,
            source: AvailableCompaniesSource.FROM_ASM,
          },
        }
      );

      return {
        items: response.targets
          ? response.targets.map(({ companyId, companyName }) => ({
              value: companyId,
              label: companyName,
            }))
          : [],
        totalItemsCount: response.totalCount,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
